// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Hm","dark":"i_Hn","light":"i_Ho","checked":"i_Hp","label":"i_Hq","icon":"i_Hr"};